import { call, delay, put } from 'redux-saga/effects'
import { replace } from 'connected-react-router'

import { Action } from '../../types'
import { ErrSuccess, PopUploadParams, Saga } from '../../types/form'
import { Response } from '../../api/api'
import { OpenApiInterface } from '../../api/requests/openApi'
import { POOLING_DELAY_CLIENT_CHECK, POLLING_DELAY_IN_MS } from '../../constants/commonConstants'
import { popActions, modalLoaderActions } from '../../redux'
import { ResponseError } from '../../utils/errors'
import Routes from '../../constants/routes'

export function* uploadPop(api: OpenApiInterface, { payload }: Action<PopUploadParams>): Saga {
  const loader = yield put(modalLoaderActions.showModalLoader())
  let i: number = 0
  let rs: Response = Response.ok
  // Loop over files to upload
  while (i < payload.files.length && rs === Response.ok) {
    const file = payload.files[i]
    const form = new FormData()

    form.append('dataSize', `${file.size / 1000} KB`)
    form.append('data', file, file.name)

    const response = yield call(api.postUploadPopFile, form)
    // Break out of the loop when an upload fails, remembering the failed position
    rs = response.responseStatus
    if (rs === Response.ok) {
      i += 1
    }
  }
  if (i === payload.files.length) {
    payload.success()
  } else if (rs === Response.networkError || rs === Response.serverErrorRetry) {
    // can send other files, report the error with option to retry with the remaining files
    payload.errorUploadFiles(payload.files.slice(i), false)
  } else {
    payload.error(rs)
  }
  yield put(modalLoaderActions.hideModalLoader(loader.id))
}

export function* processingSetup(
  api: OpenApiInterface,
  { payload: success }: Action<Function>
): Saga {
  const response = yield call(api.postPopProcessingSetup)

  if (response.responseStatus === Response.ok) {
    yield delay(POOLING_DELAY_CLIENT_CHECK)
    yield put(popActions.processingPool(success))
  } else {
    throw new ResponseError('pop saga - processingSetup', response)
  }
}

export function* processingPool(
  api: OpenApiInterface,
  { payload: success }: Action<Function>
): Saga {
  const response = yield call(api.getPopProcessingStatus)

  if (response.responseStatus === Response.ok) {
    switch (response.data?.status) {
      case 'OK':
        success()
        break
      case 'RETRY':
        yield put(popActions.processingSetup(success))
        break
      case 'IN_APPROVAL':
        yield delay(POLLING_DELAY_IN_MS)
        yield put(popActions.processingPool(success))
        break
      case 'NOK':
      default:
        yield put(replace(Routes.KO_ONLINE))
        break
    }
  } else {
    throw new ResponseError('pop saga - processingPool', response)
  }
}

export function* postStatusPoll(api: OpenApiInterface, { payload }: Action<ErrSuccess>): Saga {
  const response = yield call(api.getPopPostProcessingStatus)

  if (response.responseStatus === Response.ok) {
    switch (response.data?.status) {
      case 'OK':
        payload.success()
        break
      case 'IN_APPROVAL':
        yield delay(POOLING_DELAY_CLIENT_CHECK)
        yield put(popActions.postStatusPoll(payload))
        break
      case 'RECONFIGURE_LOAN':
        yield put(replace(Routes.LOAN_CONFIGURATOR_RE))
        break
      default:
        yield put(replace(Routes.KO_SCORING))
    }
  } else if (response.responseStatus === Response.serverErrorRetry) {
    payload.error({ type: response.responseStatus })
  } else {
    throw new ResponseError('pop saga - postStatusPoll', response)
  }
}

export function* fetchUploadPopStart(api: OpenApiInterface) {
  const response: any = yield call(api.getUploadPopStart)

  if (response.responseStatus === Response.ok) {
    const maxDocuments = response.data?.maxDocuments
    yield put(popActions.setMaxDocuments(maxDocuments))
  }
}
